import React, {useEffect, useState} from "react";
import classes from "./InstitutionManagementPage.module.css"
import {YuJaTextBox} from "../../components/standardization/YuJaTextBox";
import {
    BUTTON,
    DEFAULT_ROWS_PER_PAGE,
    YUJA_INST_CODE
} from "../../utils/constants";
import { ReactComponent as SearchIcon } from "../../images/search_bar_icon.svg";
import {ReactComponent as CLOSE} from "../../images/Close.svg"
import YuJaButton from "../../components/standardization/YuJaButton";
import {useCSMAccessCheck} from "../../hooks/useCSMAccessCheck";
import {InstitutionApiCalls} from "../../apis/InstitutionApiCalls";
import {ReactComponent as NoResultImage} from "../../images/no-result-found.svg";
import {ReactComponent as WARNING} from "../../images/Info.svg";
import Skeleton, {SkeletonTheme} from "react-loading-skeleton";
import {useConfig} from "../../hooks/useConfig";
import InstitutionManagementTable from "./InstitutionManagementTable";
import {useLocalStorageNew} from "../../hooks/useLocalStorageNew";
import {Button} from "@base-ui/react/button";
import { useTranslation, Trans } from "react-i18next";


export default function InstitutionManagementPage({setPageIdentifier}) {
    const { t } = useTranslation();
    let config = useConfig();

    const {checkInstAccess, isCSMAdmin, getAccessLevel} = useCSMAccessCheck();
    const {loadInstitutions} = InstitutionApiCalls();
    let [setIsDomainUpdated, getIsDomainUpdated] = useLocalStorageNew("isDomainUpdated", false);
    let isDomainUpdated = getIsDomainUpdated();
    setIsDomainUpdated(false);


    const [keyword, setKeyword] = useState("");
    const [loading, setLoading] = useState(true);
    const [data, setData] = useState([]);
    const [filter, setFilter] = useState({});
    const [rawData, setRawData] = useState([]);

    let columns = isCSMAdmin()
        ? [
            {Header: t("institution.csmInstitutionTableNameHeader"), accessor: "fullName", width: 200},
            {Header: t("institution.csmInstitutionTableDomainHeader"), accessor: "domain", width: 250},
            {Header: t("accessibility.typeLabel"), accessor: "type", width: 135},
            {Header: t("institution.csmInstitutionTableAccessLevelHeader"), accessor: "accessLevel", width: 150},
            {Header: t("table.actionHeader"), accessor: "action", width: 80}
        ]
        : [
            {Header: t("institution.csmInstitutionTableNameHeader"), accessor: "fullName", width: 200},
            {Header: t("institution.csmInstitutionTableDomainHeader"), accessor: "domain", width: 250},
            {Header: t("accessibility.typeLabel"), accessor: "type", width: 135},
            {Header: t("institution.csmInstitutionTableAccessLevelHeader"), accessor: "accessLevel", width: 150},
            {Header: t("table.actionHeader"), accessor: "action", width: 80}
        ];

    // columns = isCSMAdmin()
    //     ? columns.push({Header: PPT_POLLS_TABLE_ACTION_HEADER, accessor: "action", width: 100})
    //     : columns;


    useEffect(() => {
        setPageIdentifier("Institution Management");
        loadData();
    }, []);

    const loadData = () => {
        setLoading(true);
        loadInstitutions().then(async institutions => {
            institutions = institutions
                .filter(inst => inst.code !== YUJA_INST_CODE)
                .filter(inst => !!inst.shortName)
                .filter(inst => checkInstAccess(inst))
                .map(inst => {
                    inst.domain = `${inst.shortName}.${config.host_url}`;
                    inst.accessLevel = getAccessLevel(inst);
                    return inst;
                }).sort((instA, instB) => {
                    const {updateTime: updateTimeA=""} = instA;
                    const {updateTime: updateTimeB=""} = instB;
                    if (updateTimeA > updateTimeB) {
                        return -1;
                    } else if (updateTimeA < updateTimeB) {
                        return 1;
                    } else {
                        return 0;
                    }
                });

            setData(JSON.parse(JSON.stringify(institutions)));
            setRawData(institutions);
        }).finally(() => {
            setLoading(false);
        });

    };


    const clickSearch = () => {
        setFilter({ keyword: keyword});
    };


    if (loading) {
        return (
            <div className={classes.parentContainer}>
                <div className={classes.filterCard} style={{marginTop: 20}}>
                    <div
                        style={{
                            flex: 1,
                            height: 35,
                            minWidth: 200,
                            maxWidth: 1000,
                        }}
                    >
                        <Skeleton borderRadius={4} height={"100%"} inline={true} width={"100%"}/>
                    </div>
                    <Skeleton borderRadius={4} height={35} inline={true} width={75}/>
                </div>

                <div className={classes.tableContainerCard} style={{overflow: "scroll"}}>
                    <div className={classes.skeletonTableContainer}>
                        <SkeletonTheme color="rgba(237, 237, 237, 1)" highlightColor="lightgrey">
                            <div className={classes.skeletonHeaderContainer}>
                                <Skeleton borderRadius={10} height={20} inline={true} width="10vw"
                                          containerClassName={classes.skeletonBodyCellWrapper}/>
                                <Skeleton borderRadius={10} height={20} inline={true} width="6vw"
                                          containerClassName={classes.skeletonBodyCellWrapper}/>
                                <Skeleton borderRadius={10} height={20} inline={true} width="6vw"
                                          containerClassName={classes.skeletonBodyCellWrapper}/>
                                <Skeleton borderRadius={10} height={20} inline={true} width="5vw"
                                          containerClassName={classes.skeletonBodyCellWrapper}/>
                                <Skeleton borderRadius={10} height={20} inline={true} width="4vw"
                                          containerClassName={classes.skeletonBodyCellWrapper}/>

                            </div>
                            <div>
                                {Array.apply(null, Array(DEFAULT_ROWS_PER_PAGE)).map((_, idx) => {
                                    return (
                                        <div className={classes.skeletonBodyRow} key={idx}>
                                            <Skeleton
                                                borderRadius={10}
                                                height={20}
                                                inline={true}
                                                width={`${5 + (Math.random() * 8)}vw`}
                                                containerClassName={classes.skeletonBodyCellWrapper}
                                            />
                                            <Skeleton
                                                borderRadius={10}
                                                height={20}
                                                inline={true}
                                                width={`${5 + Math.random()}vw`}
                                                containerClassName={classes.skeletonBodyCellWrapper}
                                            />
                                            <Skeleton
                                                borderRadius={10}
                                                height={20}
                                                inline={true}
                                                width={`${8 + (Math.random() * 2)}vw`}
                                                containerClassName={classes.skeletonBodyCellWrapper}
                                            />
                                            <Skeleton
                                                borderRadius={10}
                                                height={20}
                                                inline={true}
                                                width={`${6 + Math.random()}vw`}
                                                containerClassName={classes.skeletonBodyCellWrapper}
                                            />
                                            <Skeleton
                                                borderRadius={10}
                                                height={20}
                                                inline={true}
                                                width={`${3 + (Math.random() * 2)}vw`}
                                                containerClassName={classes.skeletonBodyCellWrapper}
                                            />
                                        </div>
                                    )
                                })}
                            </div>
                        </SkeletonTheme>
                    </div>
                </div>
            </div>
        );
    }


    return (
        <div className={classes.parentContainer}>

            {isDomainUpdated &&
                <div className={classes.banner}>
                    <div className={classes.bannerIconContainer}>
                        <WARNING style={{width: 20, height: 20}}/>
                    </div>
                    <span style={{flex: 1}}>
                        <Trans i18nKey="institution.setupInProgress" components={{bold: <strong/>}}/>
                        {/*Once the setup is complete, it will appear in the table below.*/}
                    </span>
                </div>
            }

            <div className={classes.filterCard} style={{marginTop: 20}}>
                <YuJaTextBox
                    containerStyle={{
                        flex: 1,
                        height: 35,
                        minWidth: 200,
                        maxWidth: 1000,
                        fontSize: 14,
                        lineHeight: 1.6,
                    }}
                    onChange={e => setKeyword(e.target.value)}
                    onKeyUp={e => {
                        if (e.key === 'Enter') {
                            clickSearch();
                        }
                    }}
                    value={keyword}
                    before={<SearchIcon style={{marginRight: 5, width: 16}}/>}
                    after={
                        !!keyword
                            ? (
                                <Button
                                    aria-label={t("accessibility.clearSearchKeyword")}
                                    className={classes.closeIcon}
                                    onClick={() => {
                                        setKeyword("");
                                        setFilter({keyword: ""});
                                    }}
                                >
                                    <CLOSE style={{width: 16, height: 16}}/>
                                </Button>
                            )
                            : (<></>)
                    }
                    placeholder={t("institution.searchByNameOrDomainLower")}
                />

                <YuJaButton style={{height: 35}} onClick={clickSearch}>
                    {t("common.search")}
                </YuJaButton>
            </div>
            {!data.length &&
                <div className={classes.tableContainerCard}>
                    <NoResultImage style={{height: 150, alignSelf: "center", margin: "20px 0"}}/>
                    <span style={{alignSelf: "center", fontSize: 20, fontWeight: "600", lineHeight: 1.4}}>
                        {t("institution.noInstitutionsFound")}
                    </span>
                    <span style={{alignSelf: "center"}}>
                        {t("institution.noInstitutionsFoundDesc")}
                    </span>
                </div>
            }

            {!!data.length &&
               <InstitutionManagementTable data={data} setData={setData} columns={columns} globalFilterObj={filter} reload={loadData}/>
            }
        </div>
    );
}